<template>
  <div am-edit-user>
    <i-form-label>Name</i-form-label>
    <i-input v-model="name" />
    <i-form-label class="_margin-top:1/2">Email</i-form-label>
    <i-input v-model="email" />
    <i-form-label class="_margin-top:1/2">Role</i-form-label>
    <i-select
      v-model="role"
      :options="this.$store.state.user.allRoles"
      placeholder="Choose something.."
    />
    <div am-buttons class="_margin-top:1">
      <i-button
        link
        color="primary"
        class="_padding:0"
        @click="reset"
      >
        reset password
      </i-button>
      <i-button color="primary" am-save @click="save">
        Save
      </i-button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    role: null,
    name: null,
    email: null
  }),
  async mounted () {
    this.role = this.$store.state.user.allRoles.find(el => {
      return el.label === this.user.role
    })
    this.name = this.user.name
    this.email = this.user.email
  },
  methods: {
    ...mapMutations('notifications', ['addNotification']),
    async reset () {
      const isReset = await this.$store.dispatch('resetPassword', this.user.id)
      if (isReset) {
        navigator.clipboard.writeText(isReset.password)
        this.addNotification({
          notification: {
            type: 'success',
            message: 'Password copied to clipboard'
          }
        })
        this.$emit('changed')
      }
    },
    async save () {
      const data = { ...this.user }
      data.role = this.role.label
      data.name = this.name
      data.email = this.email
      const isSaved = await this.$store.dispatch('saveUser', data)
      if (isSaved) {
        this.$emit('changed')
      }
    }
  }
}
</script>

<style lang="scss">
[am-edit-user] {
  [am-buttons] {
    display: flex;
    justify-content: space-between;
    [am-save] {
      width: 200px;
    }
  }
}
</style>
